/** Metadata availability does not establish evidence completeness. */
export interface SalesCoverage {
  availability: "reported" | "mixed";
  dealCount: number;
  missingRecordCount: number;
  records: Array<{
    day: string;
    dealCount: number;
    sales_coverage: string | Record<string, unknown> | null;
  }>;
}

export const PARTIAL_SALES_EVIDENCE = "partial: source availability and history completeness unverified";
